import useTakeSnapshot from 'pages/Editor/sections/Flow/hooks/useTakeSnapshot';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useRecoilState } from 'recoil';
import { hyperparameterState } from 'state/atoms';
import { Hyperparameter } from 'types';

const useHyperparameter = () => {
  const [hyperparameter, setHyperparameter] = useRecoilState(hyperparameterState);
  const { takeSnapshot } = useTakeSnapshot();
  const useFormReturn = useForm<Hyperparameter>({
    defaultValues: hyperparameter,
  });
  const { watch, getValues, setValue } = useFormReturn;

  const makeVal = watch('makeVal');
  const dataRatio = watch('dataRatio');

  const handleRatioChange = useCallback(
    (newRatio: number) => {
      setValue('dataRatio', newRatio);
      setHyperparameter((prevHyperparameter) => ({
        ...prevHyperparameter,
        dataRatio: newRatio,
      }));
      takeSnapshot({ undoRedo: false });
    },
    [setValue, setHyperparameter, takeSnapshot]
  );

  const handleBlur = useCallback(
    (event: React.FormEvent<HTMLInputElement>) => {
      if (event.currentTarget.type === 'number') {
        const value = event.currentTarget.value;
        const numValue = Number(value);

        setHyperparameter({
          ...getValues(),
          [event.currentTarget.name]: numValue,
        });
        setValue(event.currentTarget.name as any, numValue);
      } else {
        setHyperparameter(getValues());
      }
    },
    [getValues, setValue, setHyperparameter]
  );

  const handleValueChange = useCallback(() => {
    takeSnapshot({ undoRedo: false });
  }, [takeSnapshot]);

  const handleMakeValChange = useCallback(
    (event: React.FormEvent<HTMLInputElement>) => {
      setValue('dataRatio', event.currentTarget.checked ? 0.99 : 1);
      handleValueChange();
    },
    [setValue, handleValueChange]
  );

  return {
    ...useFormReturn,
    makeVal,
    dataRatio,
    onBlur: handleBlur,
    onRatioChange: handleRatioChange,
    onValueChange: handleValueChange,
    onMakeValChange: handleMakeValChange,
  };
};

export default useHyperparameter;
